import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { map, switchMap, take } from 'rxjs';
import { RightsService } from '../services/rights.service';
import { TenantAccessService } from '../services/tenant-access.service';

export const adminGuard = (route: ActivatedRouteSnapshot) => {
    const rightsService = inject(RightsService);
    const tenantAccess = inject(TenantAccessService);
    const router = inject(Router);

    const tenant = route.params.tenant;

    if (tenantAccess.getTenantAccessSnapshot()) {
        return rightsService.hasAtLeastOneRightAssigned().pipe(
            take(1),
            map((hasRights) => (hasRights ? true : router.createUrlTree([tenant, 'prompts']))),
        );
    } else {
        return tenantAccess.loadTenantAccess(tenant).pipe(
            switchMap(() =>
                rightsService.hasAtLeastOneRightAssigned().pipe(
                    take(1),
                    map((hasRights) => (hasRights ? true : router.createUrlTree([tenant, 'prompts']))),
                ),
            ),
        );
    }
};
